import { FormEventHandler, PropsWithChildren } from "react";
import clsx from "clsx";

export const Form = ({
  title,
  className = "",
  onSubmit,
  children,
}: {
  title?: string;
  className?: string;
  onSubmit: FormEventHandler<HTMLFormElement>;
} & PropsWithChildren) => (
  <form className={clsx("w-full bg-white-100", className)} onSubmit={onSubmit}>
    {!!title && (
      <h1 className="text-xl md:text-4xl font-medium pb-5 text-center">
        {title}
      </h1>
    )}
    {children}
  </form>
);
